import { MemoizedSelector, createSelector } from '@ngrx/store';

import * as fromAccountInvoices from '../reducers/account-invoices.reducer';
import * as fromFeature from './../reducers';
import { AccountInvoice } from '../../model/account-invoice';
import { Entity } from '../../../shared/interfaces/entity';

export const getAccountInvoicesSlice: MemoizedSelector<
  object,
  any
> = createSelector(
  fromFeature.getAccountState,
  (state: fromFeature.AccountState) => state.accountInvoices
);

export const getAccounInvoicesEntities: MemoizedSelector<
  object,
  Entity<AccountInvoice>
> = createSelector(
  getAccountInvoicesSlice,
  fromAccountInvoices.getAccountInvoicesEntities
);

export const getAccountInvoices: MemoizedSelector<
  object,
  Array<AccountInvoice>
> = createSelector(
  getAccounInvoicesEntities,
  (entities: Entity<AccountInvoice>) => {
    return Object.keys(entities).map((id: string) => entities[+id]);
  }
);

export const getAccountInvoicesLoaded: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getAccountInvoicesSlice,
  fromAccountInvoices.getAccountInvoicesLoaded
);

export const getAccountInvoicesLoading: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getAccountInvoicesSlice,
  fromAccountInvoices.getAccountInvoicesLoading
);
